var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 0.666504H2.66659C1.93325 0.666504 1.33325 1.2665 1.33325 1.99984V11.3332H2.66659V1.99984H10.6666V0.666504ZM12.6666 3.33317H5.33325C4.59992 3.33317 3.99992 3.93317 3.99992 4.6665V13.9998C3.99992 14.7332 4.59992 15.3332 5.33325 15.3332H12.6666C13.3999 15.3332 13.9999 14.7332 13.9999 13.9998V4.6665C13.9999 3.93317 13.3999 3.33317 12.6666 3.33317ZM12.6666 13.9998H5.33325V4.6665H12.6666V13.9998Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon-copy.c8591eb80597c47f2dfc66ab4fc4dbfe.svg";
export { ForwardRef as ReactComponent };